import React from 'react';
import styles from './cardItem.module.css';
import { Link } from 'react-router-dom';
import { Book } from '../../../js/interface';

export default ({ ck, book }: { ck: Function; book: Book }) => {
  function RC(play_count: number) {
    if (play_count >= 10000000) {
      return '999.99万';
    } else {
      if (play_count >= 10000) {
        return (play_count - (play_count % 100)) / 10000 + '万';
      } else {
        return play_count;
      }
    }
  }

  function linkStr() {
    if (book.book_type === '1') {
      return `/bookDetails?id=${book.book_id}`;
    }
    if (book.book_type === '2') {
      return `/workDetails?id=${book.book_id}`;
    }
    return '';
  }

  function cardImgStyle() {
    if (!book.author) {
      return { height: '86px' };
    } else {
      return {};
    }
  }

  return (
    <>
      <Link
        to={linkStr()}
        onClick={() => {
          ck && ck();
        }}
      >
        <div className={styles.cardItem}>
          {book.cover_url && <img src={book.cover_url} className={styles.cardImg} style={cardImgStyle()}></img>}
          {book.title && <div className={styles.cardTitle}>{book.title}</div>}
          {book.author && <div className={styles.cardAuthor}>{book.author}</div>}
          {book.read_count >= 0 && <div className={styles.cardReadCount}>{RC(book.read_count)}阅读</div>}
        </div>
      </Link>
    </>
  );
};
